import { notification } from "antd";

type NotificationType = "success" | "info" | "warning" | "error";

interface NotificationProps {
  type: NotificationType;
  message: string;
  description?: string;
  duration?: number;
}

const openNotification = ({
  type,
  message,
  description,
  duration = 4.5,
}: NotificationProps) => {
  notification[type]({
    message,
    description,
    duration,
  });
};

export default openNotification;
